import { Outlet, useLocation, useParams } from '@direct-frontend/modules-router';
import { Rum } from '../Rum/Rum';
import { getRumId } from '../utils';

type RumWrapperProps = {
    pathToPageName?: (path: string) => string;
};

export const RumWrapper = (prop: RumWrapperProps) => {
    const { pathToPageName } = prop;
    const location = useLocation();
    const params = useParams();
    let pageName = location.pathname;
    const paramNames = Object.values(params);
    for (let paramName of paramNames) {
        pageName = pageName.replace(`/${paramName}`, '');
    }

    pageName = pathToPageName ? pathToPageName(pageName) : getRumId(pageName);

    return (
        <>
            <Outlet />
            <Rum key={location.key} pageName={pageName} />
        </>
    );
};
